import { render, staticRenderFns } from "./edit-organisation.vue?vue&type=template&id=0d577090&scoped=true"
import script from "./edit-organisation.vue?vue&type=script&lang=js"
export * from "./edit-organisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d577090",
  null
  
)

export default component.exports